
import React from "react";

import BsyDashChartBase from '../BsyDashChartBase'
import { BsyConfig } from '../../../global/BsyConfig'
// import { BsyDashUtils } from '../../../utils/DashUtils';
// import {echarts} from '../../../plugins/echarts.js';
import BsySLoading from '../../BsySLoading';

import './index.css';
import { BsyUtils } from "../../../utils/Utils";

export default class BsyDashMapChart extends BsyDashChartBase {


    constructor(props) {
        super(props)
        this.state = {
            ...this.state
        }
    }

    componentDidMount() {
        super.componentDidMount();
        React.axiosGet(window.rootDirectroy + "/geojson/2020-12-22/districts.json")
            .then(res => {
                this.ADDRESS_DATA = res.data;
            }).catch(res => {
                console.error(res);
            })
    }

    _initChartOption = (e, i, n, r) => {
        let _this = this;
        const { regionArea, mapType } = this.state;
        this.regionArea = regionArea;
        this.adcode = (this.regionArea && this.regionArea.adcode && this.regionArea.adcode[0]) || "100000";
        if (this.myCharts) {
            this.myCharts.dispose();
        }
        this.myCharts = window.echarts.init(this.echartsRef.current);

        this.addedBounds = [];
        this.roamIndex = 0;

        let a = '';
        switch (mapType) {
            case "area":
                a = "areaMap";
                break;
            case "bubble":
                a = "bubble";

                break;
            default:

                mapType = "area";
                break;
        }
        this.setState({
            mapType
        }, () => {
            this._registerAndsetOption(i, n, r);
        })

    }

    _renderOptions = (e, i, n, r) => {

        let o = this, s = this.props;

        let data = o.initMapData(i, n, r, o.mapJson);
        o.valMap = {
            max: data.max,
            min: data.min,
        }
        o.value = JSON.parse(JSON.stringify(data.value))

        const { mapType } = this.state;
        let option = {
            tooltip: {
                trigger: 'item',
                showDelay: 0,
                backgroundColor: "rgba(50,50,50,0.7)",
                borderColor: 'transparent',
                transitionDuration: 0.2,
                textStyle: {
                    color: "#ffffff",
                },
                formatter: function (params) {
                    //o._formatValue(params.data.value[2], 0)
                    if (params.data)
                        return params.data.name + '<br/>' + params.data.text + ': ' + o._formatValue(params.data.value[2], 0);
                    else
                        return "";
                }
            },
            //左侧的柱条
            visualMap: {
                left: 'left',
                min: o.valMap.min,
                max: o.valMap.max,
                textStyle: {
                    color: o.textColor
                },
                inRange: {
                    color: o._getColor(),
                },
                calculable: true
            },
        };
        if (mapType === "bubble") {
            option.geo = {
                map: o.name,
                roam: true,
                zoom: 1.1,
                //默认背景色与边框颜色
                itemStyle: {
                    areaColor: 'rgba(204, 204, 204,0.75)',
                    borderColor: '#ffffff'
                },
                //鼠标选择时候的背景色
                emphasis: {
                    itemStyle: {
                        areaColor: 'rgba(204, 204, 204,0.75)',
                    },
                    label: {
                        color: '#000',
                        show: false
                    }
                }
            };
            option.series = [
                {
                    type: 'scatter',
                    roam: true, //缩放
                    coordinateSystem: 'geo',
                    //标签
                    label: {
                        position: "inside",
                        color: o.textColor,
                        fontSize: o.attrList.label.fontSize,
                        fontStyle: o.attrList.label.fontStyle,
                        fontWeight: o.attrList.label.fontWeight,
                        show: true,
                        formatter: function (params) {
                            return o._labelformatter(params);
                        }
                    },
                    itemStyle: {
                        areaColor: 'rgba(204, 204, 204,0.75)',
                        borderColor: '#ffffff'
                    },
                    symbolSize: function (data, arg) {
                        return o._getScatterSize(data[2]);
                        // return Math.round(data[2] / 5);
                    },
                    data: o.value,
                }
            ]
        }
        else if (mapType === "area") {
            option.series = [
                {
                    name: o.name,
                    map: o.name,
                    type: 'map',
                    roam: true, //缩放
                    geoIndex: 0,
                    zoom: 1.1,
                    labelLayout: {
                        hideOverlap: true
                    },
                    //标签 
                    label: {
                        // position: "inside", 
                        fontSize: o.attrList.label.fontSize,
                        fontStyle: o.attrList.label.fontStyle,
                        fontWeight: o.attrList.label.fontWeight,
                        show: true,
                        color: o.textColor,
                        formatter: function (params) {
                            return o._labelformatter(params);
                        }
                    },
                    emphasis: {

                        itemStyle: {
                            areaColor: 'rgba(204, 204, 204)',
                        },
                        label: {
                            color: o.textColor,
                            show: true
                        }
                    },
                    itemStyle: {
                        areaColor: 'rgba(204, 204, 204,0.75)',
                        borderColor: '#ffffff'
                    },
                    data: o.value,
                }
            ]
        }

        return { ...option }
    }

    _renderMap = () => {
        let o = this, s = this.props;
        const { mapType, region } = this.state;
        let option = {
            tooltip: {
                trigger: 'item',
                showDelay: 0,
                backgroundColor: "rgba(50,50,50,0.7)",
                borderColor: 'transparent',
                transitionDuration: 0.2,
                textStyle: {
                    color: "#ffffff",
                },
                formatter: function (params) {
                    //o._formatValue(params.data.value[2], 0)
                    if (params.data)
                        return params.data.name + '<br/>' + params.data.text + ': ' + o._formatValue(params.data.value[2], 0);
                    else
                        return "";
                }
            },
            //左侧的柱条
            visualMap: {
                left: 'left',
                min: o.valMap.min,
                max: o.valMap.max,
                textStyle: {
                    color: o.textColor
                },
                inRange: {
                    color: o._getColor(),
                },
                calculable: true
            },
        };
        if (mapType == "bubble") {
            option.geo = {
                map: o.name,
                roam: true,
                zoom: o.adcode == "500000" ? 0.001 : 1.1,
                //默认背景色与边框颜色
                itemStyle: {
                    areaColor: 'rgba(204, 204, 204,0.75)',
                    borderColor: '#ffffff'
                },
                //鼠标选择时候的背景色
                emphasis: {
                    itemStyle: {
                        areaColor: 'rgba(204, 204, 204,0.75)',
                    },
                    label: {
                        color: '#000',
                        show: false
                    }
                }
            };
            option.series = [
                {
                    type: 'scatter',
                    roam: true, //缩放
                    coordinateSystem: 'geo',
                    //标签
                    label: {
                        position: "inside",
                        color: o.textColor,
                        fontSize: o.attrList.label.fontSize,
                        fontStyle: o.attrList.label.fontStyle,
                        fontWeight: o.attrList.label.fontWeight,
                        show: true,
                        formatter: function (params) {
                            return o._labelformatter(params);
                        }
                    },
                    itemStyle: {
                        areaColor: 'rgba(204, 204, 204,0.75)',
                        borderColor: '#ffffff'
                    },
                    symbolSize: function (data, arg) {
                        return o._getScatterSize(data[2]);
                        // return Math.round(data[2] / 5);
                    },
                    data: o.value,
                }
            ]
        }
        else if (mapType == "area") {
            option.series = [
                {
                    name: o.name,
                    map: o.name,
                    type: 'map',
                    roam: true, //缩放
                    geoIndex: 0,
                    zoom: o.adcode == "500000" ? 0.001 : 1.1,
                    labelLayout: {
                        hideOverlap: true
                    },
                    //标签 
                    label: {
                        // position: "inside", 
                        fontSize: o.attrList.label.fontSize,
                        fontStyle: o.attrList.label.fontStyle,
                        fontWeight: o.attrList.label.fontWeight,
                        show: true,
                        color: o.textColor,
                        formatter: function (params) {
                            return o._labelformatter(params);
                        }
                    },
                    emphasis: {

                        itemStyle: {
                            areaColor: 'rgba(204, 204, 204)',
                        },
                        label: {
                            color: o.textColor,
                            show: true
                        }
                    },
                    itemStyle: {
                        areaColor: 'rgba(204, 204, 204,0.75)',
                        borderColor: '#ffffff'
                    },
                    data: o.value,
                }
            ]
        }

        o.myCharts.setOption(option, true, true);
        o.myCharts.off('click');
        o.myCharts.on("click", function (params) {

            // if (!s.drilling) {
            //     switch (region) {
            //         case "country":
            //             s.drilling = "pc";
            //             break;
            //         case "province":
            //             s.drilling = "c";
            //             break;
            //         default:
            //             s.drilling = "none";
            //     }
            // }

            // //数据钻取
            // if (s.drilling === 'p' || s.drilling === 'pc' || s.drilling === 'c') {
            //     if (!BsyUtils.isObjectEmpty(params.data)) {
            //         o._drilling(params.data.name);
            //     }
            // }
            // 图表联动
            if (!BsyUtils.isObjectEmpty(params.data)) {
                o.name = params.data.name;//[o.regionArea.province[0],o.regionArea.city[0]].join("");
                o._getClickEvent();
            }
        })
    }
    initMapData = (i1, n, r, mapJson) => {
        this._getScatterUnit(r)
        let mapData = {};
        mapData.min = null;
        mapData.max = null;
        mapData.org_min = 0;
        mapData.org_max = 0;
        mapData.value = [];
        let _this = this; let _ = this;
        this.geoCoordMap = {};
        this.propertiesName = {};
        for (let i = 0; i < mapJson.features.length; i++) {

            let ji = n.indexOf(mapJson.features[i].properties.name);
            if (ji != -1) {
                let bb = r[0][ji];
                if (bb !== null) {
                    let val = {
                        adcode: mapJson.features[i].properties.adcode,
                        name: mapJson.features[i].properties.name,
                        value: [].concat(mapJson.features[i].properties.center).concat([bb]),
                        text: i1[0]
                    };
                    _this.propertiesName[val.name] = val;
                    mapData.value.push(val);
                    if (mapData.min === null) {
                        mapData.min = bb;
                        mapData.org_min = bb;
                        mapData.max = bb;
                        mapData.org_max = bb;
                    }

                    if (mapData.min > bb) {
                        mapData.min = bb;
                        mapData.org_min = bb;
                    }
                    if (mapData.max <= bb) {
                        mapData.max = bb;
                        mapData.org_max = bb;
                    }
                }
            }
        }

        let nn = this._calculateValueNiceDomain(mapData.min, mapData.max);
        mapData.min = nn[0];
        mapData.max = nn[0] == 0 && nn[1] < 1 ? 1 : nn[1];
        return mapData;
    }

    _registerAndsetOption = (i, n, r) => {

        let o = this, s = this.props;
        o.value = [];

        React.axiosGet(s.mapDataUrl.replace("${adcode}", o.adcode)).then(res => {

            o.mapJson = res.data;
            o.adcodeMap = o.adcodeMap || {};
            o.adcodeMap[o.adcode] = o.mapJson.properties;
            BsyUtils.forEach(o.mapJson.features, function (a1, b1) {
                o.mapJson.features[a1].properties.cp = o.mapJson.features[a1].properties.center;
                o.adcodeMap[b1.properties.adcode] = b1.properties;
            })
            // o.adcode = o.adcode
            o.name = o.adcodeMap[o.adcode].name;

            window.echarts.registerMap(o.name, o.mapJson);
            let data = o.initMapData(i, n, r, o.mapJson);
            o.valMap = {
                max: data.max,
                min: data.min,
            }
            o.value = JSON.parse(JSON.stringify(data.value))
            o._getStyles();
            o._renderMap();

        }).catch(res => {
            console.error(res);
        })



    }
    _labelformatter = (params) => {
        let o = this, s = this.props;
        if (s.chart_label) {
            if (s.chart_label.enable) {
                if (o.propertiesName[params.name]) {
                    let label = "";
                    let ss = [];
                    if (s.chart_label.value) {
                        if (s.chart_label.value.enable) {
                            ss.push(o._formatValue(o.propertiesName[params.name].value[2], 0))
                        }
                    }
                    else {
                        ss.push(o._formatValue(o.propertiesName[params.name].value[2], 0))
                    }
                    if (s.chart_label.dimension) {
                        if (s.chart_label.dimension.enable) {
                            ss.push(params.name)
                        }
                    }
                    else {
                        ss.push(params.name)
                    }
                    return ss.join("\n");
                }
            }

        }
        else {
            if (o.propertiesName[params.name]) {
                let ss = [];
                ss.push(o._formatValue(o.propertiesName[params.name].value[2], 0))
                ss.push(params.name)
                return ss.join("\n");
            }
        }
        return "";
    }
    _getClickEvent = () => {
        let t = this
            , e = this.props;
        let i = [];
        if (t.yGroups && t.yGroups[0]) {
            let n = t.nameMap && t.nameMap[this.seriesName] || this.seriesName
                , r = t._dealLinkData(t.yGroups[0], n);
            r.field = t.yGroups[0].name
            i.push(r)
        }
        if (t.xGroups && t.xGroups[0]) {
            let a = this.category || this.name
                , o = t.nameMap && t.nameMap[a] || a
                , s = t._dealLinkData(t.xGroups[0], o);
            s.field = t.xGroups[0].name
            i.push(s)
        }
        if (this.state.valueFields[0]) {
            t.linkParam = t._getLinkFilterParams(i)
            t.linkParam  = t.linkParam.concat(t.getFilterData().cond);
            BsyUtils.applyFunc(t, e.onItemClick, [t.linkParam, () => {
                if (!e.drilling) {
                    switch (t.state.region) {
                        case "country":
                            e.drilling = "pc";
                            break;
                        case "province":
                            e.drilling = "c";
                            break;
                        default:
                            e.drilling = "none";
                    }
                }

                //数据钻取
                if (e.drilling === 'p' || e.drilling === 'pc' || e.drilling === 'c') {
                    t._drilling(t.name);
                }
            }], !1)
        }

    }
    _drilling = (e) => {
        let i = this;
        this.ADDRESS_DATA ? this._drilldown(e) : React.axiosGet(window.rootDirectroy + "/geojson/2020-12-22/districts.json")
            .then(res => {


                i.ADDRESS_DATA = res.data;
                i._drilldown(e)

            }).catch(res => {
                console.error(res);
            })

    }
    _drilldown = (t) => {
        const { region, regionArea } = this.state;
        let e = this.props;
        let regionArea1 = { ...regionArea };
        let region1 = "";
        let showtool = false;
        let toolType = "";
        if (BsyUtils.isObjectEmpty(regionArea) || "country" === region && "province" !== region && "city" !== region) {
            region1 = "province";
            regionArea1.province = [t];
            regionArea1.adcode = [this.ADDRESS_DATA[t].adcode];
            showtool = true;
            toolType = "country"
        }
        else {

            if (e.drilling === "p" || "province" !== region && "province" !== region || "city" === region)
                return;

            e = regionArea.province[0];
            region1 = "city"
            regionArea1.city = [t];
            t = this.ADDRESS_DATA[e].districts[t];
            if (!t)
                return;
            regionArea1.adcode = [t.adcode]
            showtool = true;
            toolType = "province"
        }
        this.setState({
            region: region1,
            regionArea: regionArea1,
            showtool: showtool,
            toolType: toolType,
        }, () => {
            this.loadData()
        })

    }

    //计算气泡的大小
    //气泡大小为 10 -50 之间，计算 这之间的单元占比
    _getScatterUnit = (data) => {
        this.ScatterUnit = 10;
        let min = 0;
        let max = 0;
        BsyUtils.forEach(data[0], function (a1, b1) {
            let v = Math.abs(b1);
            if (v > max)
                max = v;
            if (v < min)
                min = v
        })

        this.ScatterUnit = (max - min) / 40;
    }

    _getScatterSize = (val) => {

        //计算区别比例
        let bili = Math.abs(val) / this.ScatterUnit;
        if (bili < 10)
            bili = 10
        if (bili > 50)
            bili = 50

        return bili;
    }
    _getColor = () => {
        let t = this.props
            , e = [];
        if (t.color) {
            let i = t.color.split(",");
            BsyUtils.forEach(i, function (t, i) {
                e.push(i.slice(0, 7))
            })
        } else {
            let n, r = this.palette || BsyConfig().CONST.DASH_CHART_MAP_THEME[0].value;
            BsyUtils.forEach(BsyConfig().CONST.DASH_CHART_MAP_THEME, function (t, e) {
                if (e.value === r)
                    return n = e.colors.slice(0),
                        !1
            })
            e = n
        }
        let a = []
            , o = 1 / (e.length - 1);
        BsyUtils.forEach(e, function (t, e) {
            // a.push([parseFloat((t * o).toFixed(1)), e])
            a.push(e)
        })
        return a
    }


    drilldownCountry = () => {
        let t = this
            , e = this.props;
        const { regionArea } = this.state;
        let regionArea1 = { ...regionArea };
        let region1 = "country";
        regionArea1.city = [""];
        regionArea1.adcode = []
        regionArea1.province = [""]
        t.linkParam = null;
        // BsyUtils.applyFunc(t, e.onItemClick, [t.linkParam], !1)
        this.setState({
            region: region1,
            regionArea: regionArea1,
            showtool: false,
        }, () => {
            this.loadData()
        })

    }

    drilldownProvince = (e, showtool) => {
        let t = this
            , e1 = this.props;
        const { regionArea } = this.state;
        let regionArea1 = { ...regionArea };
        let region1 = "province";
        regionArea1.city = [""];
        regionArea1.adcode = [t.ADDRESS_DATA[e].adcode]
        let i = [];
        let s = t._dealLinkData(t.xGroups[0], { province: e });
        s.field = t.xGroups[0].name
        i.push(s)
        t.linkParam = t._getLinkFilterParams(i)
        // BsyUtils.applyFunc(t, e1.onItemClick, [t.linkParam], !1)
        this.setState({
            region: region1,
            regionArea: regionArea1,
            showtool: showtool,
            toolType: 'country',
        }, () => {
            this.loadData()
        })
    }

    drilldownTool = () => {
        const { region, regionName, regionArea, showtool, toolType, drilling } = this.state;
        if (!showtool) {
            return ''
        }
        if (!regionArea[region]) {
            return ''
        }
        switch (drilling) {
            case "pc": {
                switch (toolType) {
                    case 'country': {
                        return <div className="chart-drilldown-tool">
                            <span className="tool-country drill-back" onClick={this.drilldownCountry}>{React.language("china")}</span>
                            <span className="tool-split">/</span>
                            <span className="tool-province "   >{regionArea['province'].join('')}</span>
                        </div>
                    }
                    case "province": {
                        return <div className="chart-drilldown-tool">
                            <span className="tool-country drill-back" onClick={this.drilldownCountry}>{React.language("china")}</span>
                            <span className="tool-split">/</span>
                            <span className="tool-province drill-back" onClick={e => { this.drilldownProvince(regionArea['province'].join(''), true) }} >{regionArea['province'].join('')}</span>
                            <span className="tool-split">/</span>
                            <span className="tool-city">{regionArea['city'].join('')}</span>
                        </div>
                    }

                    default: {
                        return ''
                    }
                }
            }
            case "p": {
                return <div className="chart-drilldown-tool">
                    <span className="tool-country drill-back" onClick={this.drilldownCountry}>{React.language("china")}</span>
                    <span className="tool-split">/</span>
                    <span className="tool-province "   >{regionArea['province'].join('')}</span>
                </div>

            }
            case "c": {
                return <div className="chart-drilldown-tool">
                    <span className="tool-province drill-back" onClick={e => { this.drilldownProvince(regionArea['province'].join(''), false) }} >{regionArea['province'].join('')}</span>
                    <span className="tool-split">/</span>
                    <span className="tool-city">{regionArea['city'].join('')}</span>
                </div>

            }
            default: {
                return ''
            }
        }


    }

    render() {
        const { widgetId, dataEmpty } = this.state;
        return (
            <>
                <div
                    className={'bsy-chart-body'}
                    key={widgetId}
                    ref={this.echartsRef}
                    id={widgetId}
                >
                </div>
                {
                    this.drilldownTool && this.drilldownTool()
                }
                {
                    this.showLoading()
                }
                {
                    dataEmpty ? <div className={'chart-data-empty'}><div><i className={BsyUtils._getWidgetTypeIcon(this.state.chartType)}></i><span>{React.language('widget.linkdata.empty')}</span></div></div> : ''
                }
            </>

        )
    }


}